import React, { useState, useMemo } from 'react';
import { AxiosInstance } from '../../utils';

interface MainWebFooterProps {
  events?: any[];
}

const MainWebFooter: React.FC<MainWebFooterProps> = ({ events = [] }) => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterMessage, setNewsletterMessage] = useState('');

  const handleSubmitNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newsletterEmail) {
      setNewsletterMessage('Please enter a valid email address.');
      return;
    }

    try {

 const response = await AxiosInstance.post('/api/newslettersubscribe',  { "email" : newsletterEmail } );
      
      if (response.data.result === 'Success') {
        setNewsletterMessage('Thank you for subscribing!');
        setNewsletterEmail('');
      } else {
        setNewsletterMessage('Subscription failed. Please try again.');
      }
    } catch (error) {
      setNewsletterMessage('An error occurred. Please try again later.');
    }
  };



  return (
    <footer className="mainwebfooter" role="contentinfo">
      <div className="footer-container">
        <div className="footer-content">
          {/* Footer Top Section */}
          <div className="footer-top">
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/aboutus">About Us</a></li>
                <li><a href="/teammembers">Team</a></li>
                <li><a href="/codeofconduct">Code of Conduct</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Events</h3>
              <ul>
   
                <li><a href="/blogs">Blog</a></li>
                <li><a href="/gallery">Gallery</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Get Involved</h3>
              <ul>
                <li><a href="/registermember">Become a Member</a></li>
                <li><a href="/contact">Sponsor Us</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Newsletter</h3>
              <form onSubmit={handleSubmitNewsletter} className="newsletter-form">
                <div className="form-group">
                  <input
                    type="email"
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                    placeholder="Enter your email address"
                    aria-label="Email address for newsletter subscription"
                  />
                  <button type="submit" aria-label="Subscribe to newsletter">
                    Subscribe
                  </button>
                </div>
                {newsletterMessage && (
                  <p className="newsletter-message" role="alert">
                    {newsletterMessage}
                  </p>
                )}
              </form>
            </div>
          </div>

          {/* Footer Middle Section */}
          <div className="footer-middle">
            <div className="footer-section">
              <h3>Connect With Us</h3>
              <div className="social-links" aria-label="Social media links">
                <a 
                  href="https://lnkd.in/gZ8N3Kxr" 
                  target="_about" 
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  title="LinkedIn"
                >
                  <i className="fa fa-linkedin"></i>
                </a>
                <a 
                  href="https://x.com/bsidesbangalore" 
                  target="_about" 
                  rel="noopener noreferrer"
                  aria-label="X (formerly Twitter)"
                  title="X (formerly Twitter)"
                >
                  <i className="fa fa-twitter"></i>
                </a>
                <a 
                  href="https://www.instagram.com/bsides_bangalore" 
                  target="_about" 
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  title="Instagram"
                >
                  <i className="fa fa-instagram"></i>
                </a>
                <a 
                  href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" 
                  target="_about" 
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  title="YouTube"
                >
                  <i className="fa fa-youtube"></i>
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h3>Contact Us</h3>
              <address>
                <p>Email: <a href="mailto:info@bsidesbangalore.in">info@bsidesbangalore.in</a></p>
                <p>For sponsor inquiries: <a href="mailto:sponsor@bsidesbangalore.in">sponsor@bsidesbangalore.in</a></p>
                <p>For CFP inquiries: <a href="mailto:cfp@bsidesbangalore.in">cfp@bsidesbangalore.in</a></p>
              </address>
            </div>
          </div>

          {/* Footer Bottom Section */}
          <div className="footer-bottom">
            <div className="footer-section">
              <p className="copyright">
                &copy; {new Date().getFullYear()} BSides Bangalore. All rights reserved.
              </p>
            </div>
            <div className="footer-section">
              <div className="footer-links">
                <a href="/privacypolicy">Privacy Policy</a>
                {/*<a href="/terms-of-service">Terms of Service</a>
                <a href="/sitemap">Sitemap</a>*/}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Styles */}
      <style>{`
        .mainwebfooter {
          background-color: #1a1a1a;
          color: #ffffff;
          padding: 20px 0 10px;
          border-top: 1px solid #333;
          bottom: 0;
          left: 0;
          width: 100%;
          z-index: 999;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .footer-content {
          display: flex;
          flex-direction: column;
        }

        .footer-top {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 25px;
          border-bottom: 1px solid #333;
        }

        .footer-section h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #ffffff;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .footer-section ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-section ul li {
          margin-bottom: 10px;
        }

        .footer-section ul li a {
          color: #cccccc;
          text-decoration: none;
          transition: color 0.3s ease, padding-left 0.3s ease;
          display: inline-block;
        }

        .footer-section ul li a:hover {
          color: #00d4ff;
          padding-left: 5px;
        }

        .newsletter-form {
          margin-top: 15px;
        }

        .form-group {
          display: flex;
          gap: 10px;
          margin-bottom: 10px;
        }

        /* Mobile newsletter form layout - force vertical stacking */
        @media (max-width: 768px) {
          .form-group {
            flex-direction: column;
            gap: 12px;
          }
        }

        .newsletter-form input[type="email"] {
          flex: 1;
          padding: 12px;
          border: 1px solid #444;
          border-radius: 4px;
          background-color: #2a2a2a;
          color: #ffffff;
          font-size: 14px;
        }

        .newsletter-form input[type="email"]::placeholder {
          color: #888;
        }

        .newsletter-form button {
          padding: 12px 20px;
          background-color: #00d4ff;
          color: #000000;
          border: none;
          border-radius: 4px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .newsletter-form button:hover {
          background-color: #00a8cc;
        }

        .newsletter-message {
          font-size: 14px;
          margin: 0;
          color: #00d4ff;
        }

        .footer-middle {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 25px;
          padding: 10px 0;
          border-bottom: 1px solid #333;
        }

        .social-links {
          display: flex;
          gap: 15px;
          margin-top: 15px;
          justify-content: center;
        }

        .social-links a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background-color: #333;
          color: #ffffff;
          border-radius: 50%;
          text-decoration: none;
          transition: all 0.3s ease;
          border: 1px solid #444;
        }

        .social-links a:hover {
          background-color: #00d4ff;
          color: #000000;
          transform: translateY(-2px);
        }

        .social-links i {
          font-size: 18px;
        }

        address {
          font-style: normal;
          line-height: 1.6;
        }

        address p {
          margin: 5px 0;
        }

        address a {
          color: #00d4ff;
          text-decoration: none;
        }

        address a:hover {
          text-decoration: underline;
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 20px;
          flex-wrap: wrap;
          gap: 15px;
        }

        /* Additional mobile improvements */
        @media (max-width: 480px) {
          .footer-top,
          .footer-middle {
            gap: 20px;
            padding-bottom: 25px;
          }
          
          .footer-bottom {
            gap: 10px;
            padding-top: 15px;
          }
          
          .footer-section h3 {
            font-size: 16px;
            margin-bottom: 15px;
          }
          
          .footer-section ul li {
            margin-bottom: 8px;
          }
          
          .newsletter-form {
            margin-top: 10px;
          }
          
          .form-group {
            gap: 8px;
          }
          
          .newsletter-form input[type="email"] {
            padding: 10px;
            font-size: 13px;
          }
          
          .newsletter-form button {
            padding: 10px 16px;
            font-size: 13px;
          }
          
          .social-links {
            gap: 12px;
          }
          
          .social-links a {
            width: 35px;
            height: 35px;
          }
          
          .social-links i {
            font-size: 16px;
          }
          
          .copyright {
            font-size: 12px;
          }
          
          .footer-links {
            gap: 15px;
          }
          
          .footer-links a {
            font-size: 12px;
          }
        }

        .copyright {
          font-size: 14px;
          color: #888;
          margin: 0;
        }

        .footer-links {
          display: flex;
          gap: 20px;
        }

        .footer-links a {
          color: #cccccc;
          text-decoration: none;
          font-size: 14px;
          transition: color 0.3s ease;
        }

        .footer-links a:hover {
          color: #00d4ff;
        }

        /* Responsive Styles */
        @media (max-width: 768px) {
          .footer-top,
          .footer-middle {
            grid-template-columns: 1fr;
          }

          .form-group {
            flex-direction: column;
          }

          .newsletter-form button {
            width: 100%;
          }

          .footer-bottom {
            flex-direction: column;
            text-align: center;
          }

          .footer-links {
            justify-content: center;
          }
        }
      `}</style>
    </footer>
  );
};

export default MainWebFooter;